<template>
  <v-app :class="!!$mq.phone ? 'mobile' : ''">
    <v-main class="transparent">
      <v-app-bar dense fixed :flat="!show.navbar" :color="!!show.navbar ? '' : 'transparent'" >
        <v-fade-transition>
          <v-toolbar-title>
            <router-link
              v-if="!!show.navbar" 
              class="nav-logo"
              :to="{ path: '/', hash:'#home' }"
            >
              <v-img class="nav-logo-img" :src="logo" contain />
            </router-link>
          </v-toolbar-title>
        </v-fade-transition>

        <v-spacer></v-spacer>

        <v-app-bar-nav-icon 
          @click="toggleNavigationDrawer" 
          :class="!!show.navbar || [ 'Terms', 'Privacy' ].includes( $route.name ) ? 'custom-gray-text' : 'custom-white-text'"
        />
      </v-app-bar>

      <NavigationDrawer 
        ref="drawer" 
        @run="run" 
      />

      <router-view 
        class="router-view"
        @prompt="prompt" 
        @run="run"
        :screen = screen
      ></router-view>
    </v-main>
    
    <cookie-law class="custom-gray" v-on:accept="privacyPolicyAccepted()">
      <div slot-scope="props" class="d-flex flex-fill align-center pa-0">
        <p class="custom-white-text ma-0">
          Ce site utilise des témoins de connexion.<br>Cliquez
          <router-link :to="{ path: '/privacy', hash: '#' }">ici</router-link> 
          pour en apprendre davantage sur notre politique de confidentialité.
        </p>

        <v-spacer></v-spacer>
        
        <v-btn 
          class="skew " 
          @click="props.accept"
        >
          <span class="custom-gray-text">J'ai compris</span>
        </v-btn>
      </div>
    </cookie-law>

    <v-snackbar v-model="show.snackbar" bottom>
      <div class="d-flex align-center">
        {{ snackbar }}

        <v-spacer></v-spacer>

        <v-btn
          class="custom-green-text"
          fab
          text
          @click="clearSnackbar"
        >
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </div>
    </v-snackbar>
  </v-app>
</template>

<script>
import NavigationDrawer from '@/components/NavigationDrawer.vue'
import ContactForm from '@/components/ContactForm'
import CookieLaw from 'vue-cookie-law'
const logo = require( "@/assets/img/nav-logo.png" )

export default {
  name: 'App',
  components: {
    ContactForm,
    NavigationDrawer,
    CookieLaw,
  },
  head: {
    meta: [
      { 
        name: `description`,
        content: process.env.VUE_APP_DESCRIPTION,
        id: `desc`,
      },
      {
        name: `keywords`,
        content: `SUP, paddleboard, planche à pagaie, réparation, époxy, fibre de verre, fissure, perforation`,
      },
      {
        name: `author`,
        content: process.env.VUE_APP_AUTHOR,
      },
      {
        property: `og:url`,
        content: `${ process.env.VUE_APP_WEBSITE_PROTOCOL }://${ process.env.VUE_APP_WEBSITE_URL }`
      },
      {
        property: `og:title`,
        content: `${ process.env.VUE_APP_ORG}: ${ process.env.VUE_APP_SLOGAN }`
      },
      {
        property: `og:type`,
        content: `website`
      },
      {
        property: `og:description`,
        content: process.env.VUE_APP_DESCRIPTION
      },
      {
        property: `og:site_name`,
        content: `${ process.env.VUE_APP_WEBSITE_URL}`
      },
      {
        property: `og:locale`,
        content: `fr_CA`
      },
      {
        property: `og:image`,
        content: `${ process.env.VUE_APP_WEBSITE_PROTOCOL }://${ process.env.VUE_APP_WEBSITE_URL }${ logo }`
      },
      {
        property: `og:image:alt`,
        content: `${ process.env.VUE_APP_ORG}: ${ process.env.VUE_APP_DESCRIPTION }`
      },
    ],
    script: [
      {
        type: "application/ld+json",
        i: JSON.stringify({
          "@context": "https://schema.org",
          "@type": "Corporation",
          "address": process.env.VUE_APP_ADDRESS,
          "url": process.env.VUE_APP_WEBSITE_URL,
          "email": process.env.VUE_APP_EMAIL,
          "telephone": process.env.VUE_APP_PHONE,
          "founder": process.env.VUE_APP_FOUNDER,
          "knowsLanguage": "fr, en",
          "legalName": process.env.VUE_APP_LEGAL_NAME,
          "logo": logo,
          "slogan": process.env.VUE_APP_SLOGAN,
          "description": `${ process.env.VUE_APP_ORG }: ${ process.env.VUE_APP_DESCRIPTION }`,
        })
      }
    ]
  },
  data() {
    return {
      logo: logo,
      screen: {
        height: 0,
        width: 0,
      },
      snackbar: null,
      show: {
        dialog: false,
        contactForm: false,
        navigation: false,
        navbar: false,
        snackbar: false,
      }
    }
  },  
  methods: {
    run( method, params ) {
      if( typeof this[ method ] === 'function' ) {
        !!params ? this[ method ]( params ) : this[ method ]()
      }
    },
    privacyPolicyAccepted() {
      //this.prompt( 'Merci!' )
    },
    prompt( msg ) {
      this.snackbar = msg
      this.show.snackbar = true
    },
    clearSnackbar() {
      this.show.snackbar = false
      this.snackbar = null
    },
    toggleNavigationDrawer() {
      this.$refs.drawer.show = !this.$refs.drawer.show
    },
    contact( params = [] ) {
      this.show.contactForm = true
      this.show.dialog = true
    },
    close() {
      this.show.contactForm = false
      this.dialog = false
    },
    handleScroll ( e ) {
      let homeLogoPos = document.querySelectorAll('.header-logo')[0].getBoundingClientRect().bottom
      this.show.navbar = homeLogoPos < 0 ? true : false
    },
    handleResize( e ) {
      this.screen.height = window.innerHeight
      this.screen.width = window.innerWidth
    },
  },
  mounted() {
    this.handleResize()
  },
  created () {
    window.addEventListener('scroll', this.handleScroll)
    window.addEventListener("resize", this.handleResize)
    document.getElementsByName('viewport')[0].content = 'width=device-width, initial-scale=1, maximum-scale=1, user-scalable=no, minimal-ui'
  },
  destroyed () {
    window.removeEventListener('scroll', this.handleScroll)
    window.removeEventListener("resize", this.handleResize)
  },
  watch: {
    '$route' (to, from) {
      document.title = to.meta.title || `${ process.env.VUE_APP_ORG}: ${ process.env.VUE_APP_SLOGAN }`
    }
  },
}
</script>

<style lang="scss">
@import './scss/variables.scss';

html {
  width: 100%;
  max-width: 100%;
  font-size: 18px;
}

body,
#app {
  max-width: 100% !important;
}

#app.mobile {
  -ms-overflow-style: none;  /* IE and Edge */
  scrollbar-width: none;  /* Firefox */
}

#app.mobile::-webkit-scrollbar {
  display: none;
}

.container {
  max-width: 100% !important;
  overflow-x: hidden !important;
}

* {
  font-family: $body-font-family;
}

html,
body,
#app { 
  background-color: #F5F5F1;
  color: #2D2A29;
  height: 100%;
  min-height: 100%;
}

h1, 
h2, 
h3, 
h4, 
h5, 
p, 
.v-card__text {
  color: #2D2A29;
}

.custom-green-text {
  color: #30B700 !important;
}
.custom-gray-text {
  color: #2D2A29 !important;
}
.custom-white-text,
.custom-white-text > a {
  color: #F5F5F1 !important;
}

.custom-green {
  background-color: #30B700 !important;
}
.custom-gray {
  background-color: #2D2A29 !important;
}
.custom-white {
  background-color: #F5F5F1 !important;
}

.transparent{
  background-color: transparent !important;
}
.semi-gray {
  background-color: rgba(45,42,41,0.5) !important;
}
.gray-75 {
  background-color: rgba(45,42,41,0.85) !important;
}
.gray-25 {
  background-color: rgba(45,42,41,0.25) !important;
}
.semi-white {
  background-color: rgba(255,255,255,0.5) !important;
}
.white-75 {
  background-color: rgba(255,255,255,0.75) !important;
}
.semi-black{
  background-color: rgba(0,0,0,0.6) !important;
} 

footer {
  position: fixed;
  bottom: 0;
  z-index: 100;
}

.router-view {
  position: absolute;
  height: 100%;
  width: 100%;
}

.nav-logo-img {
  max-width: 125px;
}

.v-card__title > * {
  word-break: normal;
}

.v-navigation-drawer--right > .v-navigation-drawer__border {
  right: 0 !important;
}

span.v-btn__content {
  line-height: normal;
}
</style>